import { z } from 'zod';

/**
 * AB#2108 (Admin V1 P0-2) — "Create your business" on /my-business.
 *
 * Messages are i18n keys (rendered with `t()`). The name is 3–100 characters:
 * the Businesses.Name column holds 100 and every later Business Details save
 * (UpdateBusinessRequestValidator) requires 3–100. City ≤ 100 mirrors
 * SaveDraftRequestValidator. `country` is an ISO-2 code, which the backend
 * BusinessCountryResolver maps to the country + currency — the pilot markets only.
 */
export const CREATE_BUSINESS_COUNTRIES = ['AE', 'JO'] as const;

export const createBusinessSchema = z.object({
    businessName: z
        .string()
        .trim()
        .min(3, 'mybiz.create.error.name')
        .max(100, 'mybiz.create.error.name'),
    country: z.enum(CREATE_BUSINESS_COUNTRIES),
    city: z
        .string()
        .trim()
        .min(2, 'mybiz.create.error.city')
        .max(100, 'mybiz.create.error.city'),
});

export type CreateBusinessForm = z.infer<typeof createBusinessSchema>;
